import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BASEURL, errorToast, successToast } from "../../utils/utils";
import "./navbar.css";

const Navbar = () => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 800) setIsMobileView(true);
    else setIsMobileView(false);
    window.addEventListener("resize", function () {
      if (this.window.innerWidth < 800) setIsMobileView(true);
      else setIsMobileView(false);
    });
  }, [window.innerWidth]);

  const handleFakeLogin = () => {
    axios
      .post(BASEURL + "/user/profile", {
        walletAddress: "xyz",
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.data.token) {
          successToast("Login Successfull");
          localStorage.setItem("token", JSON.stringify(res.data.data.token));
        }
      })
      .catch((e) => {
        console.log(e);
        errorToast("Something went wrong, try again after sometime");
      });
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="py-2 flex justify-between items-center w-4/5">
        <div className="cursor-pointer">
          <Link to="/">
            <p className="font-bold text-3xl">PreMint</p>
          </Link>
        </div>
        {isMobileView ? (
          <div
            className=" w-[30px] cursor-pointer"
            onClick={() => setIsMenuOpen((p) => !p)}
          >
            <i className="w-full fa-solid fa-bars"></i>{" "}
          </div>
        ) : isMenuOpen || !isMobileView ? (
          <div>
            <ul className={`${isMobileView ? "block" : "flex"} navbar-ul`}>
              <li>For Creators</li>
              <li>For Collectors</li>
              <li>
                <button
                  onClick={() => {
                    console.log("ran...............");
                    handleFakeLogin();
                  }}
                  className="bg-[color:var(--purple-color)] h-8 px-6 rounded-lg text-white"
                >
                  Login
                </button>
              </li>
              <li>
                <button className="text-[color:var(--purple-color)] h-8  border-[2px] border-[color:var(--purple-color)] px-6 rounded-lg text-white">
                  Started
                </button>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
      {isMobileView && isMenuOpen && (
        <div className="w-4/5">
          <ul className={`${isMobileView ? "block" : "flex"} navbar-ul`}>
            <li>For Creators</li>
            <li>For Collectors</li>
            <li
              onClick={() => {
                console.log("ran...............");
                handleFakeLogin();
              }}
            >
              <button className="bg-[color:var(--purple-color)] h-8 px-6 rounded-lg text-white">
                Login
              </button>
            </li>
            <li>
              <button className="text-[color:var(--purple-color)] h-8  border-[2px] border-[color:var(--purple-color)] px-6 rounded-lg text-white">
                Started
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Navbar;
